import {styles} from "../styles";
import {BookmarkTabs} from "../../../assets";
import React, {useEffect, useState} from "react";
import {getLicenses, LicenseCardType, LicensesType} from "../../../axios/api";

export const Licenses = () => {
    const [data, setData] = useState<LicenseCardType[] | null>(null)

    useEffect(() => {
        getLicenses().then(setInfo).catch(console.error);
    }, []);

    const setInfo = (d: LicensesType) => {
        setData(d.results)
    }
    return <div className={styles.container}>
        <h2 className={styles.title}><img src={BookmarkTabs}/>Лицензии и регистрация ПО</h2>
        {data?.map((item) => <div key={item.id} className={styles.content}>
            {item.image && <img className={styles.image} src={item.image}/>}
            <div className={styles.text} dangerouslySetInnerHTML={{__html: item.text}}></div>
        </div>)}
    </div>
}